<template>
  <div id="marcasProductos">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget title="MARCAS DE PRODUCTO" color="primary darken-4" dark>
            <div slot="widget-content">
              <div>
                <v-btn
                  color="success"
                  dark
                  fab
                  small
                  slot="activator"
                  @click="abrirDialogNuevaMarca"
                >
                  <v-icon dark>add</v-icon>
                </v-btn>
                <form-marca
                  :marca="marca"
                  ref="dialogMarca"
                  @onMarcaAdded="onMarcaAdded"
                  @onMarcaUpdated="onMarcaUpdated"
                ></form-marca>
              </div>

              <v-layout row wrap>
                <v-flex lg6 sm12 xs12>
                  <v-card>
                    <v-card-text class="pa-0">
                      <template>
                        <v-data-table
                          :headers="headers"
                          :items="marcas"
                          hide-actions
                          class="elevation-0 table-styling"
                        >
                          <template slot="items" slot-scope="props">
                            <td>
                              <v-icon color="primary">album</v-icon>
                            </td>
                            <td>BRAND-{{ zeroFill(props.item.marcaId, 3) }}</td>
                            <td>{{ props.item.nombreMarca }}</td>
                            <td class="text-xs-right">
                              <v-btn
                                flat
                                icon
                                color="grey"
                                @click="getMarcaProducto(props.item.marcaId)"
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <v-btn
                                flat
                                icon
                                color="grey"
                                :loading="$store.state.loadingDelete.show"
                                @click="deleteMarcaProducto(props.item.marcaId)"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </td>
                          </template>
                        </v-data-table>
                      </template>
                      <v-divider></v-divider>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import formMarca from "./FormMarca";
import marcaProductoService from "@/services/marcaProductoService";

import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    VWidget,
    formMarca,
    confirm,
    loadingAlert,
    snackBar,
  },
  data() {
    return {
      headers: [
        { text: "", align: "center", sortable: false },
        {
          text: "CLAVE",
          align: "left",
          value: "marcaId",
          visibility: "hidden-lg-only",
        },
        { text: "NOMBRE MARCA", align: "center", value: "nombreMarca" },
        { text: "ACCIONES", value: "acciones", align: "right" },
      ],
      marcas: [],
      marca: {
        marcaId: 0,
        nombreMarca: "",
      },
    };
  },
  mounted() {
    this.getMarcasProducto();
  },
  methods: {
    abrirDialogNuevaMarca() {
      this.$store.state.tituloForm = "AGREGAR MARCA";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogMarca.resetForm();
      this.$refs.dialogMarca.openDialog();
    },
    getMarcasProducto() {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      marcaProductoService
        .getAll()
        .then((result) => {
          self.marcas = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    getMarcaProducto(marcaId) {
      let self = this;

      self.$store.state.loadingInfo.show = true;
      marcaProductoService
        .get(marcaId)
        .then((result) => {
          self.$store.state.tituloForm = "MODIFICAR MARCA PRODUCTO";
          self.$store.state.iconoForm = "/images/general/actualizar-40.png";

          self.$refs.dialogMarca.resetForm();
          self.marca = result;
          self.$refs.dialogMarca.openDialog();
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    deleteMarcaProducto(id) {
      let self = this;

      this.$refs.confirm
        .open(
          "ELIMINAR MARCA PRODUCTO",
          "¿Estás seguro de eliminar la marca de producto seleccionado?",
          { color: "red" }
        )
        .then((confirm) => {
          if (confirm) {
            self.$store.state.loadingDelete.show = true;

            marcaProductoService
              .delete(id)
              .then((result) => {
                var i = this.marcas.findIndex((obj) => obj.marcaId == id);
                self.marcas.splice(i, 1);

                self.$store.state.snackbar.color = "success";
                self.$store.state.snackbar.text =
                  "Marca de producto eliminado con éxito";
                self.$store.state.snackbar.visible = true;
              })
              .catch((e) => {
                console.log(e);
                self.operationFailed(e);
              })
              .finally(() => {
                self.$store.state.loadingDelete.show = false;
              });
          } else {
            self.$store.state.snackbar.color = "error";
            self.$store.state.snackbar.text = "Operación cancelada";
            self.$store.state.snackbar.visible = true;
          }
        });
    },
    onMarcaAdded(marca) {
      this.marcas.push(marca);
    },
    onMarcaUpdated(marca) {
      var i = this.marcas.findIndex((obj) => obj.marcaId == marca.marcaId);
      this.marcas.splice(i, 1, marca);
    },
  },
};
</script>

<style>
thead tr th {
  background-color: #00202c;
  color: white !important;
  max-height: 15px;
}
thead tr th i {
  color: white !important;
}
</style>
